import React, { useLayoutEffect, useRef } from "react";

type RenderGameCardProps = {
  isGameFinished: boolean;
  children: React.ReactNode;
};

const RenderGameCard = ({ isGameFinished, children }: RenderGameCardProps) => {
  const frontRef = useRef<HTMLDivElement>(null);
  const winSquareRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
  const front = frontRef.current;
  const winSquare = winSquareRef.current;

  if (!front || !winSquare) return;

  const resize = () => {
    const size = Math.min(front.offsetWidth, front.offsetHeight);
    const sizeVw = (size / window.innerWidth) * 100;

    winSquare.style.width = `${sizeVw}vw`;
    winSquare.style.height = `${sizeVw}vw`;
  };

  resize();

  const observer = new ResizeObserver(resize);
  observer.observe(front);

  return () => observer.disconnect();
}, []);

  return (
    <div className="navigatorСode-card-container">
      <div
        className={`navigatorСode-card ${isGameFinished ? "navigatorСode-card-flipped" : ""}`}
      >
        {/* Передняя сторона */}
        <div ref={frontRef} className="navigatorСode-card-face navigatorСode-card-front">
          {children}
        </div>

        {/* Задняя сторона */}
        <div className="navigatorСode-card-face navigatorСode-card-back">
          <div ref={winSquareRef} className="navigatorСode-win-square">
            <img
              className="navigatorСode-win-image"
              src="/img/umnichka.svg"
              alt="Победа"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RenderGameCard;
